import * as React from 'react';
import { StateContext } from './state';
import { createInstance } from './createInstance';
import { PiralView, Mediator, ResponsiveLayout, PortalRenderer } from './components';
/**
 * Represents the Piral app shell frame. Use this component together
 * with an existing instance to render the app shell.
 * Includes layout and routing handling. Wires the state container
 * to the generated views.
 *
 * @example
```jsx
const app = (
  <Piral instance={yourPiralInstance}>
    <Define name="Layout" component={MyLayout} />
  </Piral>
);
```
 */
export const Piral = ({ instance = createInstance(), breakpoints, children }) => (React.createElement(StateContext.Provider, { value: instance.context },
    React.createElement(ResponsiveLayout, { breakpoints: breakpoints }),
    React.createElement(Mediator, { options: instance.options }),
    React.createElement(PiralView, null,
        React.createElement(PortalRenderer, { id: "root" }),
        children)));
Piral.displayName = 'Piral';
//# sourceMappingURL=Piral.js.map